// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modal_modalWrapper__LWW8H","inside":"modal_inside__MchNh"};